import * as Yup from 'yup';

const validationSchema = values =>
  Yup.object().shape({
    fio: Yup.string().required('Full name is required'),
  });

export default validationSchema;
